import React from "react";
import Contact from "../components/contact/Contact";

const ContactPage = () => {
  return (
    <div id="contact">
      <Contact />
    </div>
  );
};

export default ContactPage;
